import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_menu_ext_RowClass, bl_cms_menu_hdr_RowClass} from '../../../dbschema';

export class MenuContainerModel extends BaseContainerModel {

  bl_cms_menu_hdr: bl_cms_menu_hdr_RowClass = new bl_cms_menu_hdr_RowClass();
  bl_cms_menu_exts: bl_cms_menu_ext_RowClass[] = [];
}
